import { getStore } from '../store/store';
import getCurrentSubcategory from './getCurrentSubcategory';
import { SubCategoryState } from 'owa-options-core';

export default function getCurrentSubcategoryLoadState(): SubCategoryState {
    return getStore().subCategoryLoadState.get(getCurrentSubcategory().key);
}
